// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"6b0de7c9","488":"9f4a6370"}[chunkId] + ".chunk.js";
};